<template>
  <div class="flex space-x-2">
    <div class="flex-1">
      <VSelect
        v-model="selectedAudiences"
        multiple
        :options="options"
        :selectable="selectable"
        placeholder="Select audiences to add"
        label="name"
        :disabled="disabled"
        :filterable="false"
        class="vue-select"
        @search="onSearch"
      >
        <template #list-footer>
          <li class="flex space-x-2">
            <BaseButton
              primary
              outline
              small
              :disabled="!hasPrevPage"
              class="flex-1"
              @click="fetchPrevPage"
            >
              Prev
            </BaseButton>
            <BaseButton
              primary
              outline
              small
              :disabled="!hasNextPage"
              class="flex-1"
              @click="fetchNextPage"
            >
              Next
            </BaseButton>
          </li>
        </template>
      </VSelect>
    </div>
    <div class="flex-none">
      <BaseButton type="button" primary outline small @click="addSelectedAudiences">
        Add
      </BaseButton>
    </div>
  </div>
</template>

<script>
import { accountAudiencesClient } from '@/api/clients';
import { debounce, uniqBy } from 'lodash-es';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabled: Boolean,
  },
  data() {
    return {
      selectedAudiences: [],
      options: [],
      meta: null,
      search: '',
      page: 1,
    };
  },
  computed: {
    hasPrevPage() {
      return (this.meta?.current_page || 1) > 1;
    },
    hasNextPage() {
      return (this.meta?.last_page || 1) > (this.meta?.current_page || 1);
    },
  },
  created() {
    this.fetchOptions();
  },
  methods: {
    selectable(option) {
      return this.value.findIndex((audience) => audience.id === option.id) === -1;
    },
    onSearch(search, loading) {
      loading(true);
      this.searchOptions(loading, search, this);
    },
    searchOptions: debounce((loading, search, vm) => {
      // eslint-disable-next-line no-param-reassign
      vm.search = search;
      vm.fetchOptions().finally(() => loading(false));
    }, 350),
    async fetchOptions() {
      try {
        const response = await accountAudiencesClient.list(this.accountId, {
          filter: {
            search: this.search,
          },
          page: this.page,
        });

        this.setOptions(response.data);
        this.setMeta(response.meta);

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
    setOptions(options) {
      this.options = options;
    },
    setMeta(meta) {
      this.meta = meta;
    },
    fetchPrevPage() {
      if (!this.hasPrevPage) {
        return;
      }
      this.page = this.meta.current_page - 1;
      this.fetchOptions();
    },
    fetchNextPage() {
      if (!this.hasNextPage) {
        return;
      }
      this.page = this.meta.current_page + 1;
      this.fetchOptions();
    },
    addSelectedAudiences() {
      this.$emit('input', uniqBy([...this.value, ...this.selectedAudiences], 'id'));
      this.selectedAudiences = [];
    },
  },
};
</script>
